import React from 'react';
import { useStore } from '../../store/useStore';
import { DocumentUpload, Tabs } from '../ui';
import { FileText, ShieldCheck, FileSpreadsheet } from 'lucide-react';

export function M17_GeneralDocs() {
  const { generalDocs, setGeneralDocs } = useStore();

  const tabs = [
    {
      id: 'juridico',
      label: 'Contratos & Jurídico',
      icon: <ShieldCheck size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6">
           <DocumentUpload 
              label="Modelos de Contratos e Acordos"
              description="Suba PDFs ou DOCs de contratos padrão, NDA, termos de serviço digitais da empresa."
              maxFiles={20}
              onChange={(files) => setGeneralDocs({ contratos: files as any[] })}
           />
        </div>
      )
    },
    {
      id: 'planilhas',
      label: 'Planilhas Estruturais',
      icon: <FileSpreadsheet size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6">
           <DocumentUpload 
              label="Planilhas de Preços, Estoque, etc."
              description="Suba Excel/CSV com regras de frete, precificação e catálogos crus, fluxos de despesas, etc."
              maxFiles={20}
              onChange={(files) => setGeneralDocs({ planilhas: files as any[] })}
           />
        </div>
      )
    },
    {
      id: 'outros',
      label: 'Outros Documentos',
      icon: <FileText size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6">
           <DocumentUpload 
              label="Materiais Auxiliares e Livros Brutos"
              description="Qualquer outro PDF gerencial ou material cru que ajude a entender a empresa estruturalmente e que a Inteligência precise saber."
              maxFiles={30}
              onChange={(files) => setGeneralDocs({ outros: files as any[] })}
           />
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-gray-900">Documentos Gerais</h2>
        <p className="text-gray-500 mt-1">
          Cofre de PDFs: Contratos, Planilhas Estruturais e Materiais Complementares. Adicione o máximo de documentos que puder para enriquecer o contexto.
        </p>
      </div>

      <Tabs tabs={tabs} />
    </div>
  );
}
